import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box } from '@mui/material';
import { useSetRecoilState } from 'recoil';
import { Order } from '../../interfaces/Order/Order';
import { getOrdersByIDs } from '../../api/Order';
import { Waiting } from '../../components/Waiting/Waiting';
import { OrderDetailsPaper } from '../Order/OrderDetails/OrderDetailsPaper';
import { shippingProvidersAtom } from '../../atoms/ShippingProvider';
import { getShippingProviders } from '../../api/ShippingProvider';

export const PrintOrdersPage = () => {
  const { orderIDs: orderIDsAsStr } = useParams<string>();

  const setShippingProviders = useSetRecoilState(shippingProvidersAtom);

  const orderIDs = orderIDsAsStr?.split(',').map(Number) ?? [];

  const [orders, setOrders] = useState<Order[]>([]);
  const [loadingShippingProviders, setLoadingShippingProviders] =
    useState(false);
  const [loadingOrders, setLoadingOrders] = useState(false);

  const loading = loadingOrders || loadingShippingProviders;

  useEffect(() => {
    setLoadingShippingProviders(true);
    getShippingProviders()
      .then((s) => setShippingProviders(s))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoadingShippingProviders(false));
  }, []);

  useEffect(() => {
    setLoadingOrders(true);
    getOrdersByIDs(orderIDs)
      .then((res) => setOrders(res.data))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoadingOrders(false));
  }, [orderIDsAsStr]);

  useEffect(() => {
    if (loading) {
      return () => {};
    }

    const t = setTimeout(() => window.print(), 500);

    return () => {
      clearTimeout(t);
    };
  }, [loading]);

  if (loading) {
    return <Waiting open />;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        minWidth: 800,
        alignItems: 'center',
        backgroundColor: 'white',
        minHeight: '100vh',
        gap: 1.5,
      }}
    >
      {orders.map((order, i) => (
        <OrderDetailsPaper
          key={order.id}
          order={order}
          width={800}
          breakPage={i < orders.length - 1}
        />
      ))}
    </Box>
  );
};
